"use client"
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import '../../assets/styles/scss/_dailyDeals.scss'
import {period} from 'pp-web';
import Link from 'next/link';
import {Tooltip} from "@mui/material";
import {formatPrice} from "../../utils";
import ValuePropIntro from "../Landing/ValuePropIntro";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

function formatISODate(isoString) {
    const [year, month, day] = isoString.split("T")[0].split("-");
    return `${period.MONTHS[parseInt(month, 10) - 1]} ${parseInt(day, 10)}, ${year}`;
}

const responsive = {
    desktopExtraLarge: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
    desktopLarge: { breakpoint: { max: 3000, min: 2000 }, items: 4 },
    desktop: { breakpoint: { max: 2000, min: 1500 }, items: 3.5 },
    desktopMid: { breakpoint: { max: 1500, min: 1200 }, items: 3 },
    desktopMini: { breakpoint: { max: 1200, min: 1024 }, items: 2.5 },
    tablet: { breakpoint: { max: 1024, min: 700 }, items: 2 },
    tabletMini: { breakpoint: { max: 700, min: 464 }, items: 1.5 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
};

export default function DailyDeals(props) {
    const {dailyDeals} = props

    const LeftArrow = ({ onClick }) => {
        return <button
            className="position-absolute top-50 start-0 translate-middle-y btn btn-light shadow"
            onClick={onClick}
            style={{zIndex: 10}}
        >
            &lt;
        </button>
    }

    const RightArrow = ({ onClick }) => {
        return <button
            className="position-absolute top-50 end-0 translate-middle-y btn btn-light shadow"
            onClick={onClick}
            style={{zIndex: 10}}
        >
            &gt;
        </button>
    }

    return (
        <div className="row">
            <ValuePropIntro {...props}/>
            <Carousel
                responsive={responsive}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={1500}
                arrows={true}
                showDots={false}
                pauseOnHover={true}
                customLeftArrow={<LeftArrow />}
                customRightArrow={<RightArrow />}
            >
                {
                    dailyDeals?.data?.map((item, index) => (
                        <Card sx={{
                            display: 'flex',
                            height: '100%',
                            boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            borderRadius: '8px',
                            my: 2
                            }} className="daily-deals-product-card">
                            <div className="position-relative daily-deals-product-card-media">
                                <CardMedia
                                    component="img"
                                    className="daily-deals-product-img"
                                    image={item?.image}
                                    alt={item?.title}
                                />
                                <span className="daily-deals-product-discount">{item?.percentage}%</span>
                            </div>
                            <div class="daily-deals-product-card-detail">
                                {/* Title - Top 50% */}
                                <div style={{
                                    flex: 1,
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    height: '40%'
                                }}>
                                    <Tooltip title={item?.title} placement="top">
                                        <Typography component="div" variant="h5"
                                                    className="daily-deals-product-title">
                                            {item.title?.length > 45 ? `${item.title.slice(0, 45)}...` : item.title}
                                        </Typography>
                                    </Tooltip>

                                </div>

                                {/* Price & Button - Bottom 50% */}
                                <div style={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-end',
                                    height: '60%'
                                }}>
                                    <Typography
                                        variant="subtitle1"
                                        component="div"
                                        sx={{color: 'text.secondary'}}
                                        className="daily-deals-product-price"
                                    >
                                        {formatPrice(item?.discountedPrice)}
                                        <span
                                            className="daily-deals-product-previous-price"><s>{formatPrice(item?.price)}</s></span>
                                    </Typography>

                                    <div className="d-flex justify-content-between">
                                        <p className="daily-deals-product-valid-title">Valid till</p>
                                        <p className="daily-deals-product-valid-price">{formatISODate(item.validTill)}</p>
                                    </div>

                                    <div className="d-flex justify-content-center">
                                        <Link href={item?.url} target="_blank">
                                            <button className="daily-deals-product-get-deal-btn">Get Deal
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    ))
                }
            </Carousel>
        </div>
    )
}
